define('modules/editor/views/property_boxes/image_content',['require','exports','module','./base','../../services/image_upload/index','ldsh!../../templates/property_boxes/image_content'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base"),
      ImageUploadService = require("../../services/image_upload/index");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/image_content"),
    myEvents: {
      "click .js-edit": "requestContent"
    },
    initialize: function(options){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,options);
    },
    requestContent: function(e){
      e.preventDefault();
      ImageUploadService.loadImage(this.model.get("imageUrl"),
        _.bind(function(results){
          this.model.set("imageUrl", results.url);
          this.model.set("imageId", results.id);
          this.model.getImageSize();
        }, this));
    }
  });
});

